import styled from 'styled-components';
import DatePicker from 'react-datepicker';
export default styled(DatePicker) `
  width: 100%;
  padding: 9.5px 14px;
  border-radius: .285rem;
  border: .5px rgba(34, 36, 38, 0.15) solid;
`;
